import './action/style.scss';
import classnames from 'classnames';
import React from 'react';
import Permissions from '~/settings/permissions';
import { useAppSidebar } from '../provider';
import { MenuStates } from '../provider/enums';
import MenuItem from './menu_item';
import ProjectsWorkspaceActionsMenu from './projects_workspace_actions_menu';
import ProjectsWorkspaceMenu from './projects_workspace_menu';
const Menu = () => {
    const { isCollapsed } = useAppSidebar();
    const navClass = classnames('nav-menu', {
        isCollapsed,
    });
    return (React.createElement("nav", { className: navClass },
        React.createElement(MenuItem, { title: 'Recent Activity', route: MenuStates.RecentActivity, icon: React.createElement("i", { className: 'far fa-clock icon' }), permissions: [Permissions.VIEW_RECENT_ACTIVITIES] }),
        React.createElement(MenuItem, { actionMenu: ProjectsWorkspaceActionsMenu, component: ProjectsWorkspaceMenu, title: 'Projects', route: MenuStates.ProjectsWorkspace, icon: React.createElement("i", { className: 'far fa-rocket icon' }), permissions: [Permissions.VIEW_PROJECTS_WORKSPACE_PAGE] })));
};
export default Menu;
